import type { UnpatchedConsole } from './types';

export const defaultUnpatchedConsole: UnpatchedConsole = { ...console };



// WEBPACK FOOTER //
// ../../../src/unpatchedConsole/const.ts